<template>
  <div class="performance-card__meter-percent-container">
    <span :class="getTextClasses(metrics, index)" class="performance-card__meter-percent-text" v-for="(metric, index) in metrics" :key="index">
      {{metric}}%
    </span>
  </div>
</template>

<script>
export default {
  props: {
    metrics: {
      type: Array,
      required: true
    },
    getTextClasses: {
      type: Function,
      required: true
    },
  },
}
</script>

<style>
  .performance-card__meter-percent-container {
    display: flex;
    font-weight: bold;
    font-size: 30px;
    text-align: left;
    line-height: 140%;
  }

  .meter-text--first {
    text-align: left;
  }

  .meter-text--second {
    text-align: justify;
  }

  .meter-text--last {
    text-align: right;
  }

  .meter-text--blue {
    color: #4369F4;
  }

  .meter-text--green {
    color: #00A6A4;
  }

  .meter-text--pink {
    color: #B545AA;
  }
</style>
